import { Button, Collapsible, Surface, Text } from '@cloudflare/kumo'
import { CaretDown, Question } from '@phosphor-icons/react'
import { useState, type ReactNode } from 'react'

/**
 * 화면마다 맨 위에 붙는 "이 화면 사용법". 처음엔 펼쳐져 있고, 접으면 그 화면에 대해 기억한다 (localStorage).
 * steps 는 위에서 아래로 하는 일 순서, notes 는 알아둘 것.
 */
export function HelpPanel({
  id,
  steps,
  notes,
}: {
  id: string
  steps: ReactNode[]
  notes?: ReactNode[]
}) {
  const key = `admin:help:${id}`
  const [open, setOpen] = useState(() => {
    try {
      return localStorage.getItem(key) !== '0'
    } catch {
      return true
    }
  })
  const onOpenChange = (next: boolean) => {
    setOpen(next)
    try {
      localStorage.setItem(key, next ? '1' : '0')
    } catch {
      // 무시
    }
  }
  return (
    <Collapsible.Root open={open} onOpenChange={onOpenChange}>
      <Surface className="rounded-lg p-0" data-testid="help-panel">
        <Collapsible.Trigger
          render={
            <Button variant="ghost" className="w-full justify-between rounded-lg px-5 py-3" />
          }
        >
          <span className="flex items-center gap-2">
            <Question size={18} />이 화면 사용법
          </span>
          <CaretDown
            size={16}
            className={open ? 'rotate-180 transition-transform' : 'transition-transform'}
          />
        </Collapsible.Trigger>
        <Collapsible.Panel>
          <div className="flex flex-col gap-3 px-5 pb-5 text-sm">
            <ol className="list-decimal space-y-1.5 pl-5">
              {steps.map((s, i) => (
                <li key={i}>{s}</li>
              ))}
            </ol>
            {notes && notes.length > 0 && (
              <div className="border-kumo-line flex flex-col gap-1 border-t pt-3">
                <Text variant="secondary" size="xs">
                  알아둘 것
                </Text>
                <ul className="text-kumo-subtle list-disc space-y-1 pl-5">
                  {notes.map((n, i) => (
                    <li key={i}>{n}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </Collapsible.Panel>
      </Surface>
    </Collapsible.Root>
  )
}
